import React, {Component} from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import * as ROUTES from '../../utils/routes';
import { withFirebase } from '../Firebase';
import { AuthUserContext } from '../Session';

import ProjectsPage from '../Page_Projects';
import TranslatePage from '../Page_Translate';
import ChooseLanguagePage from '../Page_Project_Language';
import ApprovePage from '../Admin_Approve';
import DownloadPage from '../Admin_Download';
import UploadPage from '../Admin_Upload';
import SeedPage from '../Admin_Seed';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authUser: null,
        };
    }

    componentDidMount() {
        this.listener = this.props.firebase.auth.onAuthStateChanged(
            authUser => {
                if(authUser) {
                    this.setState({authUser})
                } else {
                    this.setState({authUser: null});
                }
            }
        );
    }
    componentWillUnmount() {
        this.listener();
    }

    render() {
        return (
            <AuthUserContext.Provider value={this.state.authUser}>
                <Router>
                    <div className="App">
                        <Route exact path={ROUTES.PROJECTS} component={ProjectsPage} />
                        <Route exact path={ROUTES.PROJECT_LANGUAGES} component={ChooseLanguagePage} />
                        <Route path={ROUTES.PROJECT_TRANSLATE} component={TranslatePage} />
                        <Route exact path={ROUTES.ADMIN_APPROVE} component={ApprovePage} />
                        <Route path={ROUTES.ADMIN_DOWNLOAD} component={DownloadPage} />
                        <Route path={ROUTES.ADMIN_UPLOAD} component={UploadPage} />
                        <Route path={ROUTES.ADMIN_SEED} component={SeedPage} />
                    </div>
                </Router>
            </AuthUserContext.Provider>
        );
    }
}

export default withFirebase(App);
